//BACKEND
export const servicesHost = 'https://adoptzi.jjdv.xyz/';
export const serviceRecommendation = servicesHost + 'recommendation/';
export const servicePetDetail = servicesHost + 'pet/';
export const serviceTrackingClick = servicesHost + 'tracking/';
export const serviceAdvertiser = servicesHost + 'partner/';

//GET IP
export const getIPAddress = 'https://geolocation-db.com/json/';

//DATA
export const TYPE_DOG = 'dog';
export const TYPE_CAT = 'cat';
export const SMALL = 'S';
export const MEDIUM = 'M';
export const BIG = 'L';
export const SEX_MALE = 'M';
export const SEX_FEMALE = 'F';
export const PET_AVAILABLE = 'available';
export const PET_ADOPTED = 'adopted';
export const PET_NOTAVAILABLE = 'not_available';

//Keys session storage
export const VISITS_DOG_PROFILE = 'visits_dogProfile';

//Event Name Tracking
export const TRACKING_PET = 'PET_CLICK';
export const TRACKING_REFUGE = 'REFUGE_CLICK';
export const TRACKING_RECOMMENDED = 'RECOMMENDED_CLICK';
export const TRACKING_PARTNER = 'PARTNER_CLICK';
export const TRACKING_NORESULTS = 'NO_RESULTS';

// Firebase
export const COLLECTION_NAME = 'petinterest';

//
export const PROJECT_NAME = 'Adoptzi';